import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    const logout = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/users/logout`,
          {
            method: "POST",
            credentials: "include",
          },
        );

        const data = await res.json();
        if (res.ok) {
          toast.success("Logged out successfully");
          navigate("/login", { replace: true });
        } else {
          throw new Error(data.message || "Failed to log out");
        }
      } catch (err) {
        toast.error(err.message || "An error occurred while logging out");
      }
    };

    logout();
  }, [navigate]);

  return <div>Logging out...</div>;
}
